import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contract-types-settings mt-4" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex justify-end" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)
const _hoisted_6 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_settings_contract_types_actions = _resolveComponent("settings-contract-types-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_settings_list_item = _resolveComponent("settings-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_settings_contract_types_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.createContractType,
          onUpdate: _ctx.updateContractType
        }, null, 8, ["loading", "is-create", "is-update", "is-delete", "initial-value", "onCreate", "onUpdate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Настройки" }),
        _createVNode(_component_the_button, {
          disabled: !_ctx.havePermissions(['contract-type-create', 'all-root-permission']),
          class: "primary small",
          onClick: _ctx.startCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить тип договора ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _createElementVNode("form", {
        class: "mt-5 bg-white border px-4 py-2",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loadSettings && _ctx.loadSettings(...args)), ["prevent"]))
      }, [
        _createVNode(_component_the_input, {
          value: _ctx.filters.name,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.name) = $event)),
          placeholder: "Название"
        }, null, 8, ["value"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_the_button, {
            class: "second text small mt-2",
            disabled: _ctx.state.is_loading,
            onClick: _ctx.reset
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_the_button, {
            class: "primary text small mt-2",
            loading: _ctx.state.is_loading,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" Поиск ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.is_loading,
              text: "При получении списка настроек уведомлений произошла ошибка",
              "error-message": _ctx.state.failure.error_state.message,
              "error-url": _ctx.state.failure.error_state.url,
              "error-status": _ctx.state.failure.error_state.status,
              onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadSettings(_ctx.state.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_list, {
              key: 1,
              loading: _ctx.state.is_loading,
              items: _ctx.state.list,
              pagination: "",
              "pagination-current-page": _ctx.state.pagination.current_page,
              "pagination-total-pages": _ctx.state.pagination.total_pages,
              onChangePage: _ctx.loadSettings
            }, {
              item: _withCtx(({ item }) => [
                _createVNode(_component_settings_list_item, {
                  item: item,
                  onUpdate: _ctx.startUpdate,
                  onDeleted: _ctx.loadSettings
                }, null, 8, ["item", "onUpdate", "onDeleted"])
              ]),
              _: 1
            }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
      ])
    ])
  ], 64))
}